const STORAGE_KEY = 'rossum:coupa-host';
const COUPA_QUERY_PARAM = 'coupahost';

export const initCoupaDetection = () => {
  try {
    if (new URLSearchParams(window.location.search).has(COUPA_QUERY_PARAM)) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  } catch {
    // sessionStorage unavailable
  }
};

export const isRunningInCoupa = (): boolean => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const useIsRunningInCoupa = (): boolean => isRunningInCoupa();
